export const ANNOUNCEMENT_TABLE_SORT_TYPES = {
    START_DATE_TIME: "START",
    END_DATE_TIME: "END",
    TITLE: "TITLE",
    CREATED_BY: "CREATED_BY",
};

export const ANNOUNCEMENT_TYPES = {
    BANNER: "BANNER",
};

export const ANNOUNCEMENT_SEVERITIES = {
    WARNING: "WARNING",
    INFO: "INFO",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
};

export const ANNOUNCEMENT_STATUSES = {
    DRAFT: "DRAFT",
    ACTIVE: "ACTIVE",
    LIVE: "LIVE",
    ARCHIVED: "ARCHIVED",
};

export const ANNOUNCEMENT_FILTER_TYPES = {
    STATUS: "STATUS",
};

export const ANNOUNCEMENT_MODALS = {
    CREATE: "CREATE",
    EDIT: "EDIT",
    DELETE: "DELETE",
};

export const ANNOUNCEMENT_ERROR_CODES = {
    END_IN_PAST: "END_IN_PAST",
    END_BEFORE_START: "END_BEFORE_START",
    START_IMMUTABLE_WHEN_LIVE: "START_IMMUTABLE_WHEN_LIVE",
    NO_TRANSLATIONS: "NO_TRANSLATIONS",
    FORBIDDEN_HTML_CONTENT: "FORBIDDEN_HTML_CONTENT",
    FORBIDDEN_STATUS: "FORBIDDEN_STATUS",
    ANNOUNCEMENT_ARCHIVED: "ANNOUNCEMENT_ARCHIVED",
};

export const ANNOUNCEMENTS_HUB_URL = "/api/announcements-hub";

export const ANNOUNCEMENTS_HUB_EVENTS = {
    ANNOUNCEMENT_CHANGED: "AnnouncementChanged",
};
